import { Image, View } from "@react-pdf/renderer";
import PdfHeader from "../../../assets/print/pdfHeader.png";

export default function PrintHeader() {
    return (
        <View
            style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                marginBottom: "10px",
                paddingTop: "10px",
            }}
            fixed
        >
            <Image src={PdfHeader} style={{ width: "400px" }} />
        </View>
    );
}
